import React, { FC, useState } from 'react';
import useSWR from 'swr';
import useFetcher from '../../utils/hooks/useFetcher';
import AddTenantAction from './addTenantAction';
import { HeaderTenantsListStyled, TenantsListActionsHeaderStyled } from './styled';
import TableTenantsList from './TableTenantList/tableTenantsList';

const Tenants: FC = () => {
    const fetcher = useFetcher();
    const { data: fetchedTenants } = useSWR(`${process.env.REACT_APP_API_URL}/tenant`, fetcher);
    const [openCreateTenantModal, setOpenCreateTenantModal] = useState<boolean>(false);

    return (
        <>
            <HeaderTenantsListStyled>
                <TenantsListActionsHeaderStyled>
                    <AddTenantAction
                        openCreateTenantModal={openCreateTenantModal}
                        setOpenCreateTenantModal={setOpenCreateTenantModal}
                    />
                </TenantsListActionsHeaderStyled>
            </HeaderTenantsListStyled>
            <TableTenantsList tenants={fetchedTenants || []} />
        </>
    );
};

export default Tenants;
